import React, { useState, useEffect }  from 'react';
import { useDispatch } from 'react-redux';
import { handleResponse } from 'actions/actionHelpers';
import { fetchNewsArticles } from 'actions/newsArticles';
import { makeStyles } from 'styles/util';
import strings from 'localization/strings';
import { useScrollToTop } from 'helpers/BrowserHelper';

import Container from 'common/Container';
import PageTitle from 'common/PageTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Loader from 'common/Loader';
import NewsArticleListItem from './NewsArticleListItem';

const useStyles = makeStyles(({ theme }) => ({
    list: {
        margin: 0,
        padding: 0,

        '& > *': {
            paddingBottom: theme.spacing(4)
        }
    }
}));

const NewsArticleListPage = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [newsArticles, setNewsArticles] = useState();

    useEffect(() => {
        dispatch(fetchNewsArticles())
            .then(handleResponse(
                response => {
                    setIsLoading(false);
                    setNewsArticles(response.payload);
                },
                () => {
                    setIsLoading(false);
                }
            ));
    }, []);

    useScrollToTop();

    return (
        <Container withPageMargins maxWidth="1000px">
            <PageTitle>{strings.newsArticles}</PageTitle>
            <Typography variant="h1" gutterBottom>{strings.newsArticles}</Typography>
            {
                isLoading && <Loader />
            }
            {
                newsArticles &&
                (
                    <List className={classes.list}>
                        {
                            newsArticles
                                .map(newsArticle => (
                                    <ListItem key={newsArticle.id} disableGutters>
                                        <ListItemText>
                                            <NewsArticleListItem newsArticle={newsArticle}/>
                                        </ListItemText>
                                    </ListItem>
                                ))
                        }
                    </List>
                )
            }
        </Container>
    );
};

export default NewsArticleListPage;
